import script from "./TheMain.vue?vue&type=script&setup=true&lang=js"
export * from "./TheMain.vue?vue&type=script&setup=true&lang=js"

import "./TheMain.vue?vue&type=style&index=0&id=d01b8bfe&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d01b8bfe"]])

export default __exports__